var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouteStopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2067 3.43543C13.6349 1.86369 11.5444 1 9.32258 1C7.09773 1 5.01022 1.86369 3.43848 3.43543C1.86674 5.00717 1 7.09773 1 9.31952C1 13.815 5.25132 17.5566 7.53721 19.5648C7.8546 19.8456 8.12623 20.0867 8.34596 20.2881C8.62064 20.5445 8.97161 20.6727 9.32258 20.6727C9.67355 20.6727 10.0245 20.5445 10.2961 20.2881C10.5159 20.0867 10.7905 19.8456 11.1079 19.5648C13.3908 17.5566 17.6421 13.815 17.6421 9.31952C17.6421 7.09773 16.7784 5.00717 15.2067 3.43543Z",
    fill: "#456EFF",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 22.9256
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteStopIcon);
export default __webpack_public_path__ + "static/media/routeStopIcon.65b2ba2b0cc600e6347039c8f21ee161.svg";
export { ForwardRef as ReactComponent };